import { stopSignalR } from "../../../initSignalR";
import { resetWhatsappStore } from "../../../whatsappStore";

export const CerrarSesion = () => {
  stopSignalR()
  resetWhatsappStore()
  localStorage.removeItem("HumayaDigital-Token");
  window.location.reload();
};
